// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".control[data-v-48399977] {\n  font-size: inherit;\n}", ""]);
// Exports
module.exports = exports;
